<template>
    <div>
        <div class="order-kpi-tab">
            <div>
                <b-row class="content">
                    <b-col md="9">
                        <div class="d-flex order-kpi-title">
                            <h2>Reported Time</h2>
                            <p>{{Item.reported_time | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}</p>
                        </div>
                    </b-col>
                    <b-col md="3">
                        <div class="control">
                            <!-- <span @click="modalEditKPI">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M20.708 5.63151C21.098 6.02151 21.098 6.65151 20.708 7.04151L18.878 8.87151L15.128 5.12151L16.958 3.29151C17.1449 3.10426 17.3985 2.99902 17.663 2.99902C17.9276 2.99902 18.1812 3.10426 18.368 3.29151L20.708 5.63151ZM2.99805 20.5015V17.4615C2.99805 17.3215 3.04805 17.2015 3.14805 17.1015L14.058 6.19151L17.808 9.94151L6.88805 20.8515C6.79805 20.9515 6.66805 21.0015 6.53805 21.0015H3.49805C3.21805 21.0015 2.99805 20.7815 2.99805 20.5015Z" fill="#999999"/>
                                </svg>
                            </span> -->
                            <!-- <b-modal :no-close-on-backdrop="true" id="modal-Assign" title="edit kPI target (Actual)" hide-footer :centered="true" ref="edit-kpiTarget">
                                <b-form>
                                    <b-row>
                                        <b-col md="12">
                                            <gofix-form-dropdown
                                                    label="Type KPI Actual"
                                                    v-model="item.typeKPI"
                                                    :options="options">
                                            </gofix-form-dropdown>
                                        </b-col>
                                        <b-col md="6">
                                            <gofix-form-input-date
                                                    desc="dd.mm.yyyy"
                                                    v-model="item.date"
                                                    :disabled="(item.typeKPI && item.typeKPI.value == 'case_reported') ? true : false"
                                                    label="Date">
                                            </gofix-form-input-date>
                                        </b-col>
                                        <b-col md="6">
                                            <gofix-form-input-time :disabled="(item.typeKPI && item.typeKPI.value == 'case_reported') ? true : false" label="Time" desc="hh:mm" v-model="item.time"></gofix-form-input-time>
                                        </b-col>
                                    </b-row>
                                </b-form>
                                <b-button-group class="d-block text-right">
                                    <gofix-button label="SUBMIT" @click="saveKPI" :loading="isAction" noBorder></gofix-button>
                                </b-button-group>
                            </b-modal> -->
                        </div>
                    </b-col>
                </b-row>
            </div>
            <div class="gofixBasicTable">
                <div class="dataList">
                    <gofix-card fullContent classContent="mb-0">
                        <b-table :tbody-tr-class="rowClass" :fields="fields" :items="items" class="orderTable table-filter table-hover table-has-fixed table-has-toprow mb-0" fixed responsive>
                            <!--<template slot="kpi" slot-scope="data">
                                <span v-if="data.item.kpi && data.item.kpi.indexOf('+') != -1" class="color-red"> {{ data.item.kpi }}</span>
                                <span  v-else class="color-red">{{ data.item.kpi }}</span>
                            </template>-->
                            <!-- <template slot="targeted" slot-scope="row">
                                {{ row.item.targeted | formatDate }}
                            </template> -->
                            <!-- <template slot="actual" slot-scope="row">
                                {{ row.item.actual | formatDate }}
                            </template> -->
                            <!-- <template slot="time_taken" slot-scope="row">
                                {{ row.item.time_taken | formatTimeTaken }}
                            </template> -->
                        </b-table>
                    </gofix-card>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment'
    export default {
        name: 'kpi-target',
        components: {},
        data () {
            return {
                fields: [
                    {
                        key: 'name',
                        label: '',
                        thClass: 'text-left td-description',
                        tdClass: 'text-left td-description',
                        thStyle: 'width: 300px',
                    },
                    {
                        key: 'targeted',
                        label: 'Targeted',
                        thClass: 'text-center',
                        tdClass: 'text-center',
                    },
                    {
                        key: 'actual',
                        label: 'Actual',
                        thClass: 'text-center',
                        tdClass: 'text-center',
                    },
                    /*{
                        key: 'time_taken',
                        label: 'Time Taken',
                        thClass: 'text-left',
                        tdClass: 'text-left',
                    },
                    {
                        key: 'kpi',
                        label: 'KPI',
                        thClass: 'text-left',
                        tdClass: 'text-left',
                    },*/
                ],
                items: [],
                activeClass: false,
                options : [
                    { label: 'FCR reply to requestor', value: 'fcr_reply_to_requestor'},
                    { label: 'First NFCR reply tro requestor', value: 'first_nfcr_reply_to_requestor'},
                    { label: 'Interim NFCR reply to requestor', value: 'interim _nfcr_reply_to_requestor'},
                    { label: 'Final NFCR reply to requestor', value: 'final _nfcrr_reply_to_requestor', },
                    { label: 'Escalation to stakeholder', value:  'escalation_to_stakeholder'},
                    { label: '1st reminder to stakeholder', value: '1st_reminder_to_stakeholder' },
                    { label: '2nd reminder to stakeholder', value: '2nd_reminder_to_stakeholder' },
                    { label: '3rd reminder to stakeholder', value: '3rd_reminder_to_stakeholder' },
                    { label: '4th reminder to stakeholder', value: '4th_reminder_to_stakeholder' },
                    { label: 'Retrieval of stakeholder response', value: 'retrieval_of_stakeholder_response' }
                ],
                item : {
                    typeKPI : { label: 'Case Reported', value: 'case_reported'},
                    date : null,
                    time : null
                },
                isAction : false,
            }
        },
        computed: {
            ...mapGetters({
                Item: "CaseManagementController/Item",
            })
        },
        created(){
            this.getCaseKPI();
        },
        methods: {
            // modalEditKPI() {
            //     let kpi = this.Order.kpi;
            //     let date = kpi.case_reported;
            //     this.item.date = new Date(date)
            //     this.item.typeKPI = { label: 'Case Reported', value: 'case_reported'}
            //     this.item.time = moment(date).format('HH:mm')
            //     this.isAction = false;
            //     this.$refs['edit-kpiTarget'].show()
            // },
            // saveKPI(){
            //     if(this.item.typeKPI.value == 'case_reported' && !this.item.date ) {
            //         return this.$alertNotification("Case reported required", "danger");
            //     }

            //     if(!this.item.date) {
            //         return this.$alertNotification("Date is required", "danger");
            //     }

            //     let dateTime =  moment(this.item.date).format('YYYY-MM-DD');
            //     if(this.item.time)
            //         dateTime =  dateTime +' '+ this.item.time+':00';
            //     else
            //         dateTime =  dateTime +' '+'00:00:00';
                
            //     if(this.item.typeKPI.value != 'case_reported' && moment(dateTime).isBefore(this.Order.kpi['case_reported'])) {
            //         return this.$alertNotification("The Date must be greater than the reported case date", "danger");
            //     }

            //     let data = {
            //         [this.item.typeKPI.value] : dateTime
            //     }

            //     this.isAction = true;
            //     this.$store.dispatch("KpiTargetController/updateKPIActual",{ id: this.Order.kpi.id, data : data})
            //         .then(response => {
            //             this.$refs['edit-kpiTarget'].hide()
            //             return this.$alertNotification("Update KPI successfully");
            //         })
            //         .catch(err => {})
            // },
            getCaseKPI() {
                this.$store.dispatch("CaseManagementController/caseKPI", this.$route.params.id)
                    .then(response => {
                        this.items = response.data.data
                    })
                    .catch(err => {})
            },
            rowClass(item, type) {
                if (item) {
                    if (item.kpi && item.kpi.indexOf('+') != -1) {
                        return 'row-deadline-red';
                    }
                }
                return null;
            }
        },
        mounted() {
        }
    }
</script>
